// https://webpack.js.org/guides/dependency-management/#requirecontext
const reportsapiFiles = require.context('./reportsapi', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const reportsapi = reportsapiFiles.keys().reduce((reportsapi, apiPath) => {
    // set './app.js' => 'app'

    const apiName = apiPath.replace(/^\.\/(.*)\.\w+$/, '$1')

    const value = reportsapiFiles(apiPath)

    reportsapi[apiName] = value.default

    return reportsapi
}, {})
export default reportsapi